import type { IAnswerWin, IAnswerWinQuestion } from '@/types/Data'
import type {
  IAnswerWinPayload,
  IGetAnswerWinQuestionList,
  IPaging,
  IUpdateAnswerWinQuestion,
  IUpdateAnswerWinQuestionImage,
} from '@/types/Request'
import { JsonToFormData } from '@/utils-ts'
import BaseService from '../BaseService'

export default class AnswerWinServices extends BaseService {
  GetAnswerWinList(payload: IPaging) {
    return this.GET<IAnswerWin[]>(this.PATHS.GET_ANSWER_WIN_LIST, payload)
  }

  CreateAnswerWin(data: IAnswerWinPayload) {
    return this.POST<string>(this.PATHS.CREATE_ANSWER_WIN, data)
  }

  UpdateAnswerWin(data: IAnswerWinPayload) {
    return this.POST<string>(this.PATHS.UPDATE_ANSWER_WIN, data)
  }

  DeleteAnswerWin(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_ANSWER_WIN, { Id })
  }

  GetAnswerWinQuestionList(payload: IGetAnswerWinQuestionList) {
    return this.GET<IAnswerWinQuestion[]>(this.PATHS.GET_ANSWER_WIN_QUESTION_LIST, payload)
  }

  UpdateAnswerWinQuestion(data: IUpdateAnswerWinQuestion) {
    return this.POST<IAnswerWinQuestion>(this.PATHS.UPDATE_ANSWER_WIN_QUESTION, data)
  }

  DeleteAnswerWinQuestion(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_ANSWER_WIN_QUESTION, { Id })
  }

  UpdateAnswerWinQuestionImage(data: IUpdateAnswerWinQuestionImage) {
    return this.POST<void>(this.PATHS.UPDATE_ANSWER_WIN_QUESTION_IMAGE, JsonToFormData(data))
  }

  UpdateAnswerWinQuestionOrder(data: {
    AnswerWinQuestionOrderModel: { Order: number; AnswerWinQuestionId: string }[]
  }) {
    return this.POST<void>(this.PATHS.UPDATE_ANSWER_WIN_QUESTION_ORDER, data)
  }

  CloneAnswerWin(AnswerWinId: string) {
    return this.POST<string>(this.PATHS.CLONE_ANSWER_WIN, { AnswerWinId })
  }

  ResetAnswerWin(AnswerWinId: string) {
    return this.POST<string>(this.PATHS.RESET_ANSWER_WIN, { AnswerWinId })
  }
}
